import { Link, type TabName } from '../app/router.tsx';
import { uiPop } from '../game/sound.ts';
import { useNestsVisible } from '../nests/store.ts';
import { Wedge } from './icons.tsx';

const TABS: { name: TabName; label: string; to: string }[] = [
	{ name: 'today', label: 'Today', to: '/' },
	{ name: 'play', label: 'Play', to: '/play' },
	{ name: 'nest', label: 'Nest', to: '/nest' },
	{ name: 'stats', label: 'You', to: '/you' },
];

/**
 * Today · Play · Nest · You: a quiet printed foot under an ink rule. The current tab is
 * set in ink, underlined in vermilion with the ↘ wedge beside it; the others are muted.
 * Hidden in a game (the board is the hero). Switching tabs makes a small pop (game/sound.ts). Today is the root: from Today, the others
 * push; between them they replace; Today goes back to it (app/router.tsx).
 *
 * Nest shows only behind the nests gate (nests/store.ts: dev mode, or a member of a nest).
 * It was "Friends" for a few days (SPA-25); James named it Nest again on 2 Nov.
 * `nests` overrides the gate (tests).
 */
export function TabBar({ current, nests }: { current: TabName; nests?: boolean }) {
	const visible = useNestsVisible();
	const tabs = TABS.filter((t) => t.name !== 'nest' || (nests ?? visible));
	return (
		<nav className="tabbar" aria-label="Main" data-tabs={tabs.length}>
			{tabs.map((t) => (
				<Link
					key={t.name}
					to={t.to}
					how="tab"
					className="tab"
					aria-current={t.name === current ? 'page' : undefined}
					onClick={(e) => {
						if (t.name !== current) uiPop(e.currentTarget);
					}}
				>
					<Wedge direction="diagonal" className="tab-mk" />
					<span className="tab-lb">{t.label}</span>
				</Link>
			))}
		</nav>
	);
}
